var _namedview, _g, _g2, _g3, _g4, _g5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDoubleSidewallDoubleBottomTemplate = function SvgDoubleSidewallDoubleBottomTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "377.20251mm",
    height: "288.20197mm",
    viewBox: "35 35 377.20251 288.20197",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    bordercolor: "#666666",
    borderopacity: 1,
    gridtolerance: 10,
    guidetolerance: 10,
    objecttolerance: 10,
    pagecolor: "#ffffff",
    showgrid: "false"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width",
    display: "inline",
    transform: "translate(-0.13232723,-0.19481579)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 134,
    y2: 134,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 225,
    y1: 134,
    y2: 133,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 225,
    y1: 134,
    y2: 135,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 133,
    y1: 134,
    y2: 133,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 133,
    y1: 134,
    y2: 135,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 178.82254,
    y: 139.76619,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "depth",
    display: "inline",
    transform: "translate(-0.13232723,-0.19481579)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 122.35072,
    y1: 129.43146,
    y2: 229.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 121.35072,
    y1: 129.43146,
    y2: 133.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 123.35072,
    y1: 129.43146,
    y2: 133.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 121.35072,
    y1: 229.43146,
    y2: 225.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.35072,
    x2: 123.35072,
    y1: 229.43146,
    y2: 225.43146,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -181.43144,
    y: 127.35072,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Depth\n        "))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "height",
    display: "inline",
    transform: "translate(-0.13232723,-0.19481579)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 134,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 133,
    y1: 89,
    y2: 93,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 135,
    y1: 89,
    y2: 93,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 133,
    y1: 129,
    y2: 125,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    x2: 135,
    y1: 129,
    y2: 125,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 139,
    y: 111,
    fill: "#000",
    fontSize: "5.33330011px",
    textAnchor: "middle",
    transform: "rotate(-90,139,111)"
  }, "\n            Height\n        "))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "translate(-0.13232723,-0.19481579)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 129,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 229,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 129,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 90,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 129,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 90,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 229,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 89,
    y2: 89,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 130,
    y1: 50,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 228,
    y1: 50,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 50,
    y2: 50,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 140,
    y1: 50,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 218,
    y1: 50,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 218,
    y1: 40,
    y2: 40,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 229,
    y1: 229,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 229,
    y1: 269,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 129,
    y1: 229,
    y2: 268,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 130,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 269,
    y2: 269,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228,
    x2: 228,
    y1: 269,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 130,
    y1: 269,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 228,
    y1: 308,
    y2: 308,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218,
    x2: 228,
    y1: 318,
    y2: 308,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    x2: 140,
    y1: 308,
    y2: 318,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 218,
    y1: 318,
    y2: 318,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 129,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 90,
    y1: 228,
    y2: 229,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 129,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 90,
    y1: 130,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    x2: 89,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 89,
    y1: 228,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 89,
    y1: 130,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 50,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 40,
    y1: 228,
    y2: 218,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    x2: 40,
    y1: 130,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 40,
    y1: 218,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 128,
    y1: 89,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    x2: 129,
    y1: 89,
    y2: 90,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 90,
    y1: 229,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    x2: 128,
    y1: 269,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    x2: 128,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 268,
    y1: 129,
    y2: 129,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 269,
    y1: 129,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 268,
    y1: 229,
    y2: 229,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 268,
    y1: 228,
    y2: 229,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 269,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 308,
    y1: 130,
    y2: 130,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269,
    x2: 308,
    y1: 228,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308,
    x2: 308,
    y1: 130,
    y2: 228,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308,
    x2: 318,
    y1: 130,
    y2: 140,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318,
    x2: 308,
    y1: 218,
    y2: 228,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318,
    x2: 318,
    y1: 140,
    y2: 218,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 268,
    y1: 89,
    y2: 129,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 268,
    y1: 89,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 230,
    y1: 90,
    y2: 89,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 268,
    y1: 229,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230,
    x2: 268,
    y1: 269,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    x2: 230,
    y1: 268,
    y2: 269,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.13232723,-0.19481579)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 229.23328,
    y1: 129.29588,
    y2: 129.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 229.23328,
    y1: 129.29588,
    y2: 229.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 229.23328,
    y1: 229.29588,
    y2: 229.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 129.23331,
    y1: 129.29588,
    y2: 229.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 129.23331,
    y1: 90.295822,
    y2: 129.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 129.23331,
    y1: 89.295822,
    y2: 90.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 229.23328,
    y1: 90.295822,
    y2: 129.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.23331,
    x2: 229.23328,
    y1: 89.295822,
    y2: 90.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 228.23331,
    y1: 89.295822,
    y2: 89.295822,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 130.23329,
    y1: 50.295826,
    y2: 89.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.23331,
    x2: 228.23331,
    y1: 50.295826,
    y2: 89.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 228.23331,
    y1: 50.295826,
    y2: 50.295826,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 140.23328,
    y1: 50.295826,
    y2: 40.295826,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.23331,
    x2: 218.23328,
    y1: 50.295826,
    y2: 40.295826,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.23328,
    x2: 218.23328,
    y1: 40.295826,
    y2: 40.295826,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 229.23328,
    y1: 229.29588,
    y2: 268.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.23331,
    x2: 229.23328,
    y1: 269.29578,
    y2: 268.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 129.23331,
    y1: 229.29588,
    y2: 268.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 130.23329,
    y1: 268.29578,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 228.23331,
    y1: 269.29578,
    y2: 269.29578,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.23331,
    x2: 228.23331,
    y1: 269.29578,
    y2: 308.29581,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 130.23329,
    y1: 269.29578,
    y2: 308.29581,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 228.23331,
    y1: 308.29581,
    y2: 308.29581,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.23328,
    x2: 228.23331,
    y1: 318.29578,
    y2: 308.29581,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.23329,
    x2: 140.23328,
    y1: 308.29581,
    y2: 318.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.23328,
    x2: 218.23328,
    y1: 318.29578,
    y2: 318.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 129.23331,
    y1: 229.29588,
    y2: 229.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.233337,
    x2: 90.233337,
    y1: 228.2959,
    y2: 229.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 129.23331,
    y1: 129.29588,
    y2: 129.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.233337,
    x2: 90.233337,
    y1: 130.29588,
    y2: 129.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.233337,
    x2: 89.233337,
    y1: 130.29588,
    y2: 228.2959,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.233337,
    x2: 89.233337,
    y1: 228.2959,
    y2: 228.2959,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.233337,
    x2: 89.233337,
    y1: 130.29588,
    y2: 130.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.233337,
    x2: 50.233337,
    y1: 130.29588,
    y2: 228.2959,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.233337,
    x2: 40.233337,
    y1: 228.2959,
    y2: 218.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.233337,
    x2: 40.233337,
    y1: 130.29588,
    y2: 140.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.233337,
    x2: 40.233337,
    y1: 218.29588,
    y2: 140.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 90.233337,
    y1: 89.295822,
    y2: 129.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 128.23331,
    y1: 89.295822,
    y2: 89.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.23331,
    x2: 129.23331,
    y1: 89.295822,
    y2: 90.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 90.233337,
    y1: 229.29588,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.233337,
    x2: 128.23331,
    y1: 269.29578,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.23331,
    x2: 128.23331,
    y1: 268.29578,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 268.23343,
    y1: 129.29588,
    y2: 129.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.23343,
    x2: 269.23343,
    y1: 129.29588,
    y2: 130.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 268.23343,
    y1: 229.29588,
    y2: 229.29588,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.23343,
    x2: 268.23343,
    y1: 228.2959,
    y2: 229.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.23343,
    x2: 269.23343,
    y1: 130.29588,
    y2: 228.2959,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.23343,
    x2: 308.23343,
    y1: 130.29588,
    y2: 130.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.23343,
    x2: 308.23343,
    y1: 228.2959,
    y2: 228.2959,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.23343,
    x2: 308.23343,
    y1: 130.29588,
    y2: 228.2959,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.23343,
    x2: 407.23343,
    y1: 130.29588,
    y2: 130.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.23343,
    x2: 308.23343,
    y1: 228.2959,
    y2: 228.2959,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.23343,
    x2: 407.23343,
    y1: 130.29588,
    y2: 228.2959,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.23343,
    x2: 268.23343,
    y1: 89.295822,
    y2: 129.29588,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.23328,
    x2: 268.23343,
    y1: 89.295822,
    y2: 89.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 230.23328,
    y1: 90.295822,
    y2: 89.295822,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.23343,
    x2: 268.23343,
    y1: 229.29588,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.23328,
    x2: 268.23343,
    y1: 269.29578,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.23328,
    x2: 230.23328,
    y1: 268.29578,
    y2: 269.29578,
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleSidewallDoubleBottomTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double-sidewall-double-bottom-template.73d5d9e0.svg";
export { ForwardRef as ReactComponent };